var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_653_57773)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_653_57773)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#E8F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.668 25V22.067C19.668 21.48 20.148 21 20.735 21H42.6C43.187 21 43.667 21.48 43.667 22.067V33.267C43.6659 33.5496 43.5531 33.8202 43.3532 34.02C43.1533 34.2197 42.8825 34.3322 42.6 34.333H39.667M16.735 25H38.6C38.883 25 39.1544 25.1124 39.3545 25.3125C39.5546 25.5126 39.667 25.784 39.667 26.067V37.267C39.6667 37.5498 39.5542 37.821 39.3541 38.0208C39.154 38.2207 38.8828 38.333 38.6 38.333H16.735C16.5949 38.3331 16.4562 38.3057 16.3267 38.2521C16.1973 38.1986 16.0796 38.1201 15.9805 38.0211C15.8815 37.9221 15.8028 37.8046 15.7492 37.6752C15.6956 37.5458 15.668 37.4071 15.668 37.267V26.067C15.668 25.784 15.7804 25.5126 15.9805 25.3125C16.1806 25.1124 16.452 25 16.735 25ZM29 31.667C29.0048 31.8452 28.974 32.0226 28.9091 32.1886C28.8443 32.3547 28.7469 32.506 28.6226 32.6338C28.4983 32.7616 28.3496 32.8631 28.1854 32.9325C28.0212 33.0018 27.8447 33.0375 27.6665 33.0375C27.4882 33.0375 27.3118 33.0018 27.1475 32.9325C26.9833 32.8631 26.8347 32.7616 26.7104 32.6338C26.5861 32.506 26.4886 32.3547 26.4238 32.1886C26.359 32.0226 26.3281 31.8452 26.333 31.667C26.3425 31.3197 26.4871 30.9897 26.7362 30.7474C26.9852 30.5051 27.319 30.3695 27.6665 30.3695C28.0139 30.3695 28.3477 30.5051 28.5967 30.7474C28.8458 30.9897 28.9905 31.3197 29 31.667Z",
    stroke: "#0069FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_653_57773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_653_57773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.d57635be1797d41d3a9f6e9aa39e2af6.svg";
export { ForwardRef as ReactComponent };